import { useEffect, useState } from "react";
import { useCategories } from "../../../lib/hooks/useCategories";
import { deleteCategory } from "../../../lib/services/categoryService";

/* Centered modal with backdrop */
const DeleteCategory = ({ onClose }) => {
  const { categories, setCategories } = useCategories();

  const [isSelectingCategory, setIsSelectingCategory] = useState(true);
  const [categoryID, setCategoryID] = useState("Select Category");

  // Close with ESC key
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const onSubmit = async () => {
    const response = await deleteCategory(categoryID);
    const data = await response.json();

    if (response.ok) {
      const newCategories = categories.filter((cat) => Number(cat.id) !== Number(categoryID));
      setCategories(newCategories);
    } else {
      alert(`Error deleting category: ${data.error}`);
    }

    onClose();
  };

  return (
    <div className="confirm-overlay" role="presentation" onClick={onClose}>
      {/* stop propagation so clicks inside the card don't close */}
      <div
        className="confirm-card"
        role="dialog"
        aria-modal="true"
        style={{
          width: "auto",
          backgroundColor: "rgb(237, 71, 9)",
          outline: "none",
          border: "none",
          color: "white",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <>
          {!!isSelectingCategory ? (
            <div className="d-flex flex-column gap-4" style={{ width: "40vh" }}>
              <div className="form-group flex-row">
                <label className="form-label">Select Category to Delete</label>
                <select
                  value={categoryID}
                  onChange={(e) => setCategoryID(e.target.value)}
                  size={6}
                >
                  {categories.map((category) => {
                    return (
                      <option
                        value={category.id}
                        key={`category-${category.id}`}
                      >
                        {category.id} - {category.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="confirm-actions">
                <button
                  className="btn confirm-no"
                  style={{
                    outline: "none",
                    border: "none",
                    color: "white",
                    backgroundColor: "darkgreen",
                  }}
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn confirm-yes"
                  style={{
                    outline: "none",
                    border: "none",
                    color: "white",
                    backgroundColor: "darkgreen",
                  }}
                  onClick={() => setIsSelectingCategory(false)}
                >
                  Continue
                </button>
              </div>
            </div>
          ) : (
            <div>
              <p className="confirm-text">
                {`Are you sure you want to delete category [ID - ${categoryID}]?`}
              </p>
              <div className="confirm-actions">
                <button
                  className="btn confirm-no"
                  style={{
                    outline: "none",
                    border: "none",
                    color: "white",
                    backgroundColor: "darkgreen",
                  }}
                  onClick={onClose}
                >
                  No
                </button>
                <button
                  className="btn confirm-yes"
                  style={{
                    outline: "none",
                    border: "none",
                    color: "white",
                    backgroundColor: "darkgreen",
                  }}
                  onClick={onSubmit}
                >
                  Yes
                </button>
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default DeleteCategory;
